import { hsl } from 'polished';
export var BrandColours;
(function (BrandColours) {
    BrandColours["BlueDark"] = "blue-dark";
    BrandColours["BlueLight"] = "blue-light";
    BrandColours["GreenDark"] = "green-dark";
    BrandColours["GreenLight"] = "green-light";
    BrandColours["OrangeDark"] = "orange-dark";
    BrandColours["OrangeMid"] = "orange-mid";
    BrandColours["OrangeLight"] = "orange-light";
    BrandColours["PinkDark"] = "pink-dark";
    BrandColours["PinkLight"] = "pink-light";
    BrandColours["PurpleDark"] = "purple-dark";
    BrandColours["PurpleLight"] = "purple-light";
    BrandColours["GreyPrimary"] = "grey-primary";
    BrandColours["White"] = "white";
})(BrandColours || (BrandColours = {}));
export default {
    global: {
        black: '#1D1D1B',
        white: '#fff',
    },
    primary: {
        grey: '#E6E7E8',
        blue: {
            light: '#00BBCE',
            dark: '#262262',
        },
        purple: {
            light: '#941E81',
            dark: '#630460',
        },
    },
    secondary: {
        green: {
            light: '#8CC747',
            mid: '#5B792F',
            dark: '#4A7729',
        },
        orange: {
            light: '#F37021',
            mid: '#C7442A',
            dark: '#B33D26',
        },
        pink: {
            light: '#F06793',
            mid: '#CF578A',
            dark: '#C2366F',
        },
        yellow: {
            light: '#FFD400',
            mid: '#FFC72C',
            dark: '#F1B300',
        },
    },
    validation: {
        invalid: '#B3261E',
    },
    grey: {
        lightest: '#EDEEEF',
        light: '#A7A9AC',
        mid: '#808285',
        dark: '#545051',
        /** Hex: #222222 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #333333 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #585858 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #666666 */
        grey40: hsl(0, 0, 0.4),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #F7F7F7 */
        grey97: hsl(0, 0, 0.97),
    },
};
